export enum ApplicationStatus {
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export enum PageLayout {
  Default = 'default',
  SideColumn = 'side_column',
}
